import React, { PropsWithChildren } from 'react';
import { VerticalMenu } from '@common/components';

export function ScheduleVerticalNav({
  children,
  hideMenu,
}: PropsWithChildren<{ hideMenu?: boolean }>) {
  // The Dashboard is the single, service-line-agnostic entry point; service line is
  // chosen via the Service Line column filter on the table, not a left-nav switcher.
  // Team Review is reached per service line from the dashboard's "Review Team" CTA.
  const items = [
    {
      name: 'Dashboard',
      iconOfKind: { icon: 'clipboardListCheck', kind: 'light' },
      redirectTo: '/works/schedule/dashboard',
    },
  ];

  return (
    <VerticalMenu items={items} menuKey="schedule-menu" hideMenu={hideMenu}>
      {children}
    </VerticalMenu>
  );
}
